export default __webpack_public_path__ + "static/media/quickswap.e517f14b.svg";